import { Component,OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {FormGroup,FormControl,Validators,FormBuilder } from "@angular/forms";
import { AuthService } from '../../providers/auth-service';
import { CommonService } from '../../services/common.service';

/**
 * Generated class for the RatingCollectorsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 @IonicPage()
 @Component({
 	selector: 'page-rating-collectors',
 	templateUrl: 'rating-collectors.html',
 })
 export class RatingCollectorsPage implements OnInit {

 	registerCredentials :any = { firstName : '', lastName : ''};
 	ratingCollectorList:any=[];
 	showTab=1;
    isUpdate=false;
     /*******Validation Start************/
     registerForm = new FormGroup({
         firstName: new FormControl(), 
         lastName: new FormControl(), 
         email: new FormControl(),
         contactNumber : new FormControl(),
         password: new FormControl(),
         confirmPassword: new FormControl(),
         userId: new FormControl() 
     });

     constructor(public navCtrl: NavController, public navParams: NavParams,private auth: AuthService,  public fb: FormBuilder , public commonService :CommonService ) {
         
     }


     ngOnInit(){ 
         this.initializeForm();
         this.getCompanyRatingCollectors();
     }

     public matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
         return (group: FormGroup) => {
             let passwordInput = group.controls[passwordKey];
             let passwordConfirmationInput = group.controls[passwordConfirmationKey];
             if (passwordInput.value !== passwordConfirmationInput.value) {
                 return passwordConfirmationInput.setErrors({notEquivalent: true})
             }
         }
     }

     ionViewDidLoad() {

 		//
 	}


 	public getCompanyRatingCollectors(){

 		this.commonService.showLoading();
 		this.commonService.getCompanyRatingCollectors().subscribe(success => {
 			this.commonService.dismisshowoading();
 			if (success && success.status=="success") {
 				this.ratingCollectorList=success.data;
 			} else {
        	 // success=JSON.parse(success);
        	 this.commonService.showPopup("No Data", success.message);
        	}
        });
 	}

 	public changeTimeToAgo= function(previous){

 		return this.commonService.timeDifference(previous);

 	}


 	public register(formValues) {

 		if(!this.isUpdate && this.registerCredentials.password!=this.registerCredentials.confirmPassword){
 			this.commonService.showPopup("Fail", "Password did not match with confirm password.");
 			return;
 		}

         //this.commonService.showLoading();

         formValues.companyId=(this.commonService.getLoggedInUserData())?this.commonService.getLoggedInUserData().companyId:'',
         this.auth.registerAdmin(formValues).subscribe(success => {


             this.commonService.dismisshowoading();
             if (success && success.status=="success") {
         	 //  this.createSuccess = true;
              if(!this.isUpdate){
                  this.registerForm.reset();
                  this.ratingCollectorList.push(success.data);
              }
              this.commonService.showPopup("Success", success.message);


          } else {
              success=JSON.parse(success);
              this.commonService.showPopup("Fail", success.message);
          }
      });	
	      	/*,
	      error => {
	        this.commonService.dismisshowoading();
	        console.log("ssssssssssss error",error);
	        this.showPopup("Error server", error);
        });*/
    }

    public veiwEditRatingCollector(user){
        this.isUpdate=true;
        this.showTab=2;
        var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        this.registerCredentials.firstName=user.fullName.split(" ")[0];
        this.registerCredentials.lastName=user.fullName.split(" ")[1];
        this.registerCredentials.email=user.email;
        this.registerCredentials.contactNumber=user.phoneNumber;
        this.registerCredentials.userId=user.userId;

        this.registerForm = this.fb.group({
            firstName: [this.registerCredentials.firstName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]{2,32}')])],
            lastName: [this.registerCredentials.lastName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]{2,32}')])],             
            email: [this.registerCredentials.email, Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
            password: [this.registerCredentials.password, Validators.minLength(6)],
            confirmPassword: [this.registerCredentials.confirmPassword, ''],
            contactNumber: [this.registerCredentials.contactNumber, Validators.compose([Validators.required, Validators.minLength(5), Validators.minLength(10)])],      
            userId:[this.registerCredentials.userId, ''],

        }, 
        {'validator': this.matchingPasswords('password', 'confirmPassword')});  

    }

    public initializeForm(){
        this.showTab=1;
        this.isUpdate=false;
        this.registerCredentials={};
        var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        this.registerForm = this.fb.group({
            firstName: [this.registerCredentials.firstName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]{2,32}')])],
            lastName: [this.registerCredentials.lastName, Validators.compose([Validators.required, Validators.pattern('[A-Za-z]{2,32}')])],             
            email: [this.registerCredentials.email, Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
            password: [this.registerCredentials.password, Validators.compose([Validators.required,  Validators.minLength(6)])],
            confirmPassword: [this.registerCredentials.confirmPassword, Validators.compose([Validators.required])],
            contactNumber: [this.registerCredentials.contactNumber, Validators.compose([Validators.required, Validators.minLength(5), Validators.minLength(10)])],      

        }, 
        {'validator': this.matchingPasswords('password', 'confirmPassword')}); 
    }

}



// WEBPACK FOOTER //
// ./src/pages/rating-collectors/rating-collectors.ts